<div class="waec-page-header">
  <img
    class="waec-page-header-image"
    src="/assets/icons/Assets_Support.svg"
    alt="Highighted_Access"
  />
  <h3 class="waec-page-header-text">{{'GENERAL.SUPPORT' | translate}}</h3>
</div>

<div class="page-container" nz-row>
  <div class="accountProfile">
    <nz-card class="ant-card-body-main" [nzBordered]="false">
      <!-- TITLE, BREADCRUMBS AND BUTTONS-->
      <div nz-row nzJustify="space-between" nzAlign="end" [nzGutter]="[8, 8]">
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="14" nzXl="16">
          <nz-skeleton
            *ngIf="!ticketDetails.length"
            [nzActive]="true"
            class="skeleton"
            [nzParagraph]="{ rows: 0.5 }"
          ></nz-skeleton>
          <h3 class="waec-card-header-text" *ngIf="ticketDetails.length">
            {{'ENQUIRY.TICKET-INFORMATION.TICKET_NUMBER' | translate}} - {{ ticketDetails[0]?.complaint_id }}
          </h3>

          <nz-breadcrumb>
            <nz-breadcrumb-item class="sub-header-text">
              <a [routerLink]="[pageRoutes.enquiry.ticketsListing]">{{'GENERAL.ALL_TICKETS' | translate}}</a>
            </nz-breadcrumb-item>
            <nz-breadcrumb-item class="sub-header-text"
              >{{'ENQUIRY.TICKET-INFORMATION.VIEW_TICKET' | translate}}</nz-breadcrumb-item
            >
          </nz-breadcrumb>
        </div>

        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="10" nzXl="8">
          <div nz-row nzJustify="space-between" [nzGutter]="[8, 8]">
            <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="11">
              <button
                nz-button
                [nzType]="'primary'"
                nzBlock
                class="text-center action-btn"
                [routerLink]="[pageRoutes.enquiry.ticketsListing]"
              >
                {{'ENQUIRY.TICKET-INFORMATION.VIEW_TICKETS' | translate}}
              </button>
            </div>

            <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="11">
              <button
                nz-button
                [nzType]="'primary'"
                nzBlock
                class="text-center action-btn"
                [routerLink]="[pageRoutes.enquiry.openTicket]"
              >
                {{'ENQUIRY.TICKET-INFORMATION.OPEN_NEW_TICKET' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- TICKET INFORMATION -->
      <div nz-row class="ticket-info-header">
        <p class="ticket-info-header-title">{{'ENQUIRY.TICKET-INFORMATION.INFO_HEADER' | translate}}</p>
        <span
          class="dot"
          nz-tooltip
          [nzTooltipTitle]="ticketStatus | translate"
          [ngClass]="
            ticketStatus.toLowerCase() == 'open' ? 'dot_success' : 'dot_error'
          "
        ></span>
      </div>

      <div nz-row nzJustify="space-between">
        <!-- SIDEBAR  -->
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="10" nzXl="7">
          <nz-skeleton
            [nzActive]="true"
            [nzParagraph]="{ rows: 5 }"
            *ngIf="!ticketDetails.length"
          ></nz-skeleton>

          <div nz-col class="ticket-info" *ngIf="ticketDetails.length">
            <nz-row class="ticket-details">
              <div nz-col>
                <p>{{'ENQUIRY.TICKET-INFORMATION.TICKET_SUBJECT' | translate}}</p>
                <h4 nz-typography nzEllipsis>{{ ticketDetails[0]?.title }}</h4>
              </div>
            </nz-row>

            <nz-row class="ticket-details">
              <div nz-col nzSpan="12">
                <p nz-col nzSpan="12">{{'GENERAL.CATEGORY' | translate}}</p>
                <h4 nz-col nzSpan="12">
                  {{ ticketDetails[0]?.category.name }}
                </h4>
              </div>

              <div nz-col nzSpan="12">
                <p nz-col nzSpan="12">{{'GENERAL.STATUS' | translate}}</p>
                <h4 nz-col nzSpan="12">
                  {{ ticketDetails[0]?.status | titlecase }} &nbsp;
                  <span
                    class="dot"
                    nz-tooltip
                    [nzTooltipTitle]="ticketStatus"
                    [ngClass]="
                    ticketStatus.toLowerCase() == 'open'
                      ? 'dot_success'
                      : 'dot_error'
                  "
                  ></span>
                </h4>
              </div>
            </nz-row>

            <nz-row class="ticket-details">
              <p nz-col nzSpan="24">{{'ENQUIRY.TICKET-INFORMATION.CREATED_ON' | translate}}</p>
              <h4 nz-col nzSpan="12">
                {{ ticketDetails[0]?.created_at | date: "MMM d, y" }}
              </h4>
              <h4 nz-col nzSpan="12">
                {{ ticketDetails[0]?.created_at | date: "hh:mm a" | uppercase}}
              </h4>
            </nz-row>

            <nz-row *ngIf="ticketDetails[0].documents.length" class="ticket-details last-child">
              <p nz-col nzSpan="24">{{'ENQUIRY.TICKET-INFORMATION.REQUESTED_DOCUMENTS' | translate}}</p>
              <h4 nz-col nzSpan="24" class="cursor-pointer" (click)="openUploadedDocumentsModal()">
                {{submittedDocCount}} {{'GENERAL.OF' | translate}} {{ticketDetails[0].documents.length}} {{'ENQUIRY.TICKET-INFORMATION.DOCUMENTS' | translate}}
              </h4>
            </nz-row>
          </div>
        </div>

        <!-- COMMENTS -->
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="13" nzXl="16">
          <div nz-row class="reply-header" nzJustify="space-between">
            <p class="ticket-info-header-comment">{{'ENQUIRY.TICKET-INFORMATION.COMMENTS' | translate}}</p>
          </div>

          <!-- CHAT/MESSAGE FLOW -->
          <div>
            <div
              #ScrollToBottom
              nz-col
              infiniteScroll
              [infiniteScrollDistance]="1"
              [infiniteScrollUpDistance]="2"
              [infiniteScrollThrottle]="300"
              [scrollWindow]="false"
              (scrolled)="onScrollDown()"
              (scrolledUp)="onScrollUp()"
              [ngClass]=" 'message-section'"
            >
              <!-- <div class="empty-state" *ngIf="!ticketDetails.length">
                <nz-empty [nzNotFoundContent]="null"></nz-empty>
                <p>No Comments</p>
              </div> -->

              <chat-message-tab
                [Username]="ticketDetails[0]?.source === userTypes.ADMIN ? getUserType(ticketDetails[0]) + '- ' + ('ENQUIRY.TICKET-INFORMATION.CREATED_BY_ADMIN' | translate) : getUserType(ticketDetails[0])"
                [Date]="ticketDetails[0]?.created_at | date: 'M/d/yy, h:mm a'"
                [Message]="ticketDetails[0]?.message"
                [FlexDirection]="true"
              ></chat-message-tab>

              <chat-message-tab
                [ngClass]="ticketComments.length ? '' : 'display-none'"
                *ngFor="let comment of ticketComments"
                [Username]=" userId == comment?.user?.id ? getUserType(comment?.user)
                   : comment?.user?.firstname 
                "
                [Date]="comment?.created_at | date: 'M/d/yy, h:mm a'"
                [Message]="comment?.message"
                [FlexDirection]="userId == comment?.user?.id ? true : false"
                [userType]="userId !== comment?.user?.id ? true : false"
              ></chat-message-tab>

              <chat-message-tab 
                (click)="openUploadModal()"
                [cta]="true"
                [ngClass]="uploadDocuments && ticketDetails[0]?.status === 'open' ? 'pointer' : 'display-none'"
                Message="{{'ENQUIRY.TICKET-INFORMATION.UPLOAD_PROMPT' | translate}}"
              ></chat-message-tab>
              
            </div>

            <form
              nz-row
              class="chatbox"
              [formGroup]="commentForm"
              (ngSubmit)="onSendComment()"
              [ngClass]="[
                ticketStatus.toLowerCase() === 'open' ? '' : 'display-none',
                ticketDetails[0]?.let_comment ? '':'display-none'
              ]"
            >
              <div nz-col nzXs="16" nzSm="19" nzMd="20" nzLg="20" nzXl="21">
                <textarea
                  formControlName="message"
                  class="textarea"
                  nz-input
                  nzAutosize
                  placeholder=""
                ></textarea>
              </div>
              <div nz-col nzXs="8" nzSm="5" nzMd="4" nzLg="4" nzXl="3">
                <button
                  nz-button
                  class="send-chat"
                  [nzType]="'primary'"
                  type="submit"
                  [disabled]="commentForm.invalid"
                  nzBlock
                >
                  {{'GENERAL.SEND' | translate}}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </nz-card>
  </div>
</div>

<!-- UPLOAD DOCUMENTS MODAL -->
<nz-modal
  [(nzVisible)]="uploadDocumentsModal"
  
  [nzMask]="true"
  nzWidth="900px"
  nzCentered="true"
  nzMaskClosable="false"
  nzClosable="false"
  (nzOnCancel)="handleModalCancel()"
>

  <ng-container *nzModalContent>

    <div nz-row>
      <div nz-col nzSpan="24" class="items-center">
        <img src="./assets/icons/documents_upload.svg" alt="">&nbsp;&nbsp;
        <p class="modal-title">{{'ENQUIRY.TICKET-INFORMATION.DOCUMENT_UPLOAD' | translate}}</p>
      </div>
    </div>
  
    <form *ngIf="documentsRequired.length" nz-form [formGroup]="uploadForm" class="upload-form">
      <div formArrayName="documentFiles">
        <div *ngFor="let control of documentsRequired; let i = index;" class="upload-item">
          <div nz-row>
            <div nz-col nzSpan="21" class="justify-between">
              <p class="modal-label"><span class="mr-1">{{i+1}}.</span><span>{{documentsRequired[i]?.document_type?.name}}</span><span class="red">&nbsp;*</span></p>
              <img *ngIf="control?.uploadStatus == 'uploaded'" src="./assets/icons/check-circle.svg" alt="">
              <img *ngIf="control?.uploadStatus == 'failed'" src="./assets/icons/x-circle.svg" alt="">
              <ng-template #indicatorTemplate><span nz-icon nzType="loading"></span></ng-template>
              <nz-spin *ngIf="control?.uploadStatus === 'uploading'" nzSimple [nzIndicator]="indicatorTemplate"></nz-spin>
              <div *ngIf="control?.fileList?.length > 0 && control?.uploadStatus === 'pending'">
                <p *ngFor="let file of control.fileList" class="m-0"><i nz-icon (click)="removeItem(file, i)" style="cursor: pointer;" nzType="delete"></i></p>
              </div>
            </div>
            <div nz-col>
              
            </div>
          </div>
          <nz-form-control [nzSpan]="21">
            <nz-upload  
              nzType="drag"
              [(nzFileList)]="control.fileList"            
            
              [nzDisabled]="control?.fileList?.length > 0 && control.uploadStatus !== 'failed'"
              [nzPreview]="handlePreview"
              (click)="setDocument(control?.formControlName)"
              [nzBeforeUpload]="preDocumentsUpload"
              (dragenter)="setDocument(control.formControlName)"
            >
            <div class="upload-wrapper">
              <p class="ant-upload-text">{{control.fileList?.length ? control.fileList[control.fileList?.length - 1]?.name : ('ENQUIRY.TICKET-INFORMATION.CLICK_OR_DRAG' | translate) }} </p>
              <img class="upload-icon" [src]="control.fileList?.length ? './assets/icons/uploaded.svg' : './assets/icons/upload.svg'"  alt="">
            </div>
              <!-- <button nz-button [disabled]="control.fileList.length > 0">
                <i nz-icon nzType="upload"></i><span>Upload {{documentsRequired[i].title}}</span>
              </button> <br> -->
            </nz-upload>  
          </nz-form-control>
          
        </div>
      </div>
    </form>
  
    <div nz-row>
      <div nz-col class="btn-wrapper">
        <button nz-button [nzType]="'primary'" [disabled]="(uploadedDocCount !== documentsRequired.length) || uploading"  class="modal-btn" (click)="submitDocuments()">
          {{('GENERAL.UPLOAD' | translate) | titlecase}}
        </button>
        <button nz-button nzType="danger" class="modal-btn" (click)="handleModalCancel()">
          <img src="assets/icons/x.svg" alt="">&nbsp;&nbsp;{{'GENERAL.CANCEL' | translate}}
        </button>
      </div>
    </div>
  </ng-container>
  <div *nzModalFooter></div>
</nz-modal>

<nz-modal
  [(nzVisible)]="uploadedDocumentsModal"
  [nzMask]="true"
  nzWidth="800px"
  nzCentered="true"
  nzMaskClosable="false"
  nzClosable="false"
  (nzOnCancel)="handleModalCancel()"
>
  <ng-container *nzModalContent>
    <div nz-row>
      <div nz-col nzSpan="24" style="text-align: right;">
        <img class="x" src="./assets/x.svg" (click)="closeModal()">
      </div>
    </div>
    <div nz-row>
      <div nz-col nzSpan="24" class="d-flex" style="align-items: center;">
        <img src="./assets/icons/documents_upload.svg" alt=""> &nbsp;&nbsp;&nbsp;
        <p class="modal-title">{{'ENQUIRY.TICKET-INFORMATION.UPLOADED_DOCUMENTS' | translate}}</p>
      </div>
    </div>
  
    <div nz-row>
      <div nz-col nzSpan="24" style="margin-top: 20px">
        <p class="p-0 text-primary">{{'ENQUIRY.TICKET-INFORMATION.UPLOADED_DOCUMENTS' | translate}}</p>
      </div>
      <div nz-col nzSpan="24" class="document-status-wrapper">
        <div style="display: flex; align-items: center;">
          <nz-select class="document-select" [(ngModel)]="doc" (ngModelChange)="showDoc()" nzPlaceHolder="{{'ENQUIRY.TICKET-INFORMATION.SELECT_DOCUMENT' | translate}}" >
            <nz-option *ngFor="let doc of this.ticketDetails[0]?.documents" [nzValue]="doc" [nzLabel]="doc?.document_type?.name"></nz-option>
          </nz-select>
          <p class="text-primary p-2 submitted-doc-count" >{{submittedDocCount}} {{'GENERAL.OF' | translate}} {{ticketDetails[0]?.documents?.length}} {{'ENQUIRY.TICKET-INFORMATION.DOCUMENTS' | translate}}</p>
        </div>
        <p class="text-primary p-2 submitted-doc-count-mobile" >{{submittedDocCount}} {{'GENERAL.OF' | translate}} {{ticketDetails[0]?.documents?.length}} {{'ENQUIRY.TICKET-INFORMATION.DOCUMENTS' | translate}}</p>
        <p class="document-status">{{'ENQUIRY.TICKET-INFORMATION.DOCUMENT_STATUS' | translate}}: <span [ngClass]="doc?.status === 'APPROVED' ? 'text-success' : (doc?.status === 'REJECTED' ? 'text-danger' : (doc?.status === 'SUBMITTED' ? 'text-primary' : ''))">{{doc?.status}}</span> </p>
      </div>
  
      <div nz-row style="margin-top: 40px;">
        <div nz-col nzSpan="24">
          <p *ngIf="doc?.url" style="font-weight: 500;">Click <a href="{{doc?.url}}" target="_blank" class="doc-link">{{'CONFIRMATION.BULK.HERE' | translate}}</a> {{'ENQUIRY.TICKET-INFORMATION.TO_VIEW' | translate}} {{doc?.document_type?.name}} {{'ENQUIRY.TICKET-INFORMATION.DOCUMENT' | translate}}</p>
        </div>
        
        <!-- <div nz-col nzSpan="24" class="document-image-container">
          <img class="document-image" [src]="selectedDocImage"/>
        </div> -->
        
      </div>
  
    </div>
  </ng-container>

  <div *nzModalFooter></div>
</nz-modal>
